import { KoreaTerms } from 'src/modules/auth/containers/RegistrationForm';

// this function checks if current term is the last mandatory term needed to accept
export const isLastMandatoryTerm = (
    hash: Record<string, boolean | string>,
    key: string,
): boolean => {
    const mandatoryKNterms = [
        KoreaTerms.TERMS,
        KoreaTerms.PRIVACY,
        KoreaTerms.USE_SENSITIVE_INFO,
        KoreaTerms.PROVISION_PERSONAL_INFO,
        KoreaTerms.OVERSEAS_XFER_PERSONAL_INFO,
    ];

    const isCurrentTermAccepted = hash[key];

    if (isCurrentTermAccepted === false) {
        const otherTerms = mandatoryKNterms.filter(name => name !== key);

        return otherTerms.every(term => !!hash[term]);
    }

    return mandatoryKNterms.every(term => !!hash[term]);
};
